<div class="theme-color-picker" [class.disabled]="disabled">
  <label class="tcp-label" *ngIf="label">
    {{ label }}<span class="required" *ngIf="required">*</span>
  </label>
  <p class="tcp-helper" *ngIf="helperText">{{ helperText }}</p>

  <div class="tcp-swatches">
    <div
      class="tcp-swatch-wrap"
      *ngFor="let sw of swatches; trackBy: trackSwatch">
      <button
        type="button"
        class="tcp-swatch"
        [class.selected]="selectedId === sw.id"
        [style.background]="sw.bg"
        [title]="sw.title"
        [disabled]="disabled"
        (click)="selectSwatch(sw, $event)">
        <svg
          *ngIf="selectedId === sw.id"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true">
          <path d="M20 6 9 17l-5-5"></path>
        </svg>
      </button>
      <button
        *ngIf="sw.isCustom"
        type="button"
        class="tcp-delete"
        title="Remove custom color"
        aria-label="Remove custom color"
        [disabled]="disabled"
        (click)="deleteCustom(sw.id, $event)">
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true">
          <path d="M18 6 6 18M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <button
      type="button"
      class="tcp-add"
      title="Add custom color"
      cdkOverlayOrigin
      #addOrigin="cdkOverlayOrigin"
      [disabled]="disabled"
      (click)="openPicker($event)">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
        <path d="M12 5v14M5 12h14"></path>
      </svg>
    </button>
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="addOrigin"
    [cdkConnectedOverlayOpen]="pickerOpen"
    [cdkConnectedOverlayPositions]="popoverPositions"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="12"
    (overlayOutsideClick)="closePicker()">
    <div class="tcp-popover" role="dialog" aria-label="Custom color">
      <div class="tcp-popover-header">
        <span>Custom color</span>
        <button type="button" class="tcp-popover-close" (click)="closePicker($event)" aria-label="Close">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true">
            <path d="M18 6 6 18M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <div class="tcp-mode" role="tablist" aria-label="Color type">
        <button type="button" role="tab" [attr.aria-selected]="mode === 'solid'" [class.active]="mode === 'solid'" (click)="setMode('solid', $event)">Solid</button>
        <button type="button" role="tab" [attr.aria-selected]="mode === 'gradient'" [class.active]="mode === 'gradient'" (click)="setMode('gradient', $event)">Gradient</button>
      </div>

      <div
        class="tcp-sv"
        [style.background]="hueBase"
        (pointerdown)="onSvPointerDown($event)">
        <div class="tcp-sv-white"></div>
        <div class="tcp-sv-black"></div>
        <div class="tcp-sv-cursor" [style.left.%]="svX" [style.top.%]="svY"></div>
      </div>

      <div class="tcp-hue" (pointerdown)="onHuePointerDown($event)">
        <div class="tcp-hue-cursor" [style.left.%]="huePct" [style.background]="hueBase"></div>
      </div>

      <div class="tcp-hex-row">
        <div class="tcp-preview" [style.background]="previewColor"></div>
        <ng-container *ngIf="mode === 'gradient'">
          <button type="button" class="tcp-stop" [class.active]="activeStop === 0" [style.background]="gradStops[0]" (click)="selectStop(0, $event)" title="Start color" aria-label="Start color"></button>
          <button type="button" class="tcp-stop" [class.active]="activeStop === 1" [style.background]="gradStops[1]" (click)="selectStop(1, $event)" title="End color" aria-label="End color"></button>
        </ng-container>
        <div class="tcp-hex-input-wrap">
          <span>#</span>
          <input
            type="text"
            maxlength="6"
            [value]="hexInput"
            (input)="onHexInput($event)"
            autocomplete="off"
            spellcheck="false"
            aria-label="Hex color" />
        </div>
      </div>

      <button type="button" class="tcp-add-palette" (click)="addCustom($event)">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true">
          <path d="M12 5v14M5 12h14"></path>
        </svg>
        Add to palette
      </button>
    </div>
  </ng-template>
</div>
